<div *ngIf="individualDeductible || annualMax">
    <h5 class="h4 ip-accumulator-title">{{ constants.PLAN_LEVEL_INDIVIDUAL | translate}}</h5>
    <div
        *ngIf="individualDeductible"
        class="ip-accumulator-container-with-background">
        <div class="ip-accumulator">
            <div class="ip-accumulator-details">
                <p
                    [id]="individualDeductible?.network + '-' + individualDeductible?.level + '-' +  individualDeductible?.coverage + '-coverage'"
                    class="h5">{{ individualDeductible?.coverage ?? '' | translate }}</p>
                <div
                    [id]="individualDeductible?.network + '-' + individualDeductible?.level + '-' +  individualDeductible?.coverage + '-total'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'TotalColon' | translate }}</p><p class="h5">{{ individualDeductible?.limit }}</p></div>
            </div>
            <vpg-simple-progress-bar
                [id]="individualDeductible?.network + '-' + individualDeductible?.level + '-' +  individualDeductible?.coverage + '-progress-bar'"
                class="ip-accumulators-progress-bar"
                [size]="'small'"
                [indicator]="false"
                [progress]="individualDeductible?.progress ?? 0">
            </vpg-simple-progress-bar>
            <div class="ip-accumulator-details">
                <div
                    [id]="individualDeductible?.network + '-' + individualDeductible?.level + '-' +  individualDeductible?.coverage + '-spent'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'SpentColon' | translate }}</p><p class="h5">{{ individualDeductible?.applied }}</p></div>
                <div
                    [id]="individualDeductible?.network + '-' + individualDeductible?.level + '-' +  individualDeductible?.coverage + '-remaining'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'RemainingColon' | translate }}</p><p class="h5">{{ individualDeductible?.remaining }}</p></div>
            </div>
        </div>
    </div>
    <div
        *ngIf="annualMax"
        class="ip-accumulator-container-with-background">
        <div class="ip-accumulator">
            <div class="ip-accumulator-details">
                <p
                    [id]="annualMax?.network + '-' + annualMax?.level + '-' +  annualMax?.coverage + '-coverage'"
                    class="h5">{{ 'AnnualMax' | translate }}</p>
                <div
                    [id]="annualMax?.network + '-' + annualMax?.level + '-' +  annualMax?.coverage + '-total'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'TotalColon' | translate }}</p><p class="h5">{{ annualMax?.limit }}</p></div>
            </div>
            <vpg-simple-progress-bar
                [id]="annualMax?.network + '-' + annualMax?.level + '-' +  annualMax?.coverage + '-progress-bar'"
                class="ip-accumulators-progress-bar"
                [size]="'small'"
                [indicator]="false"
                [progress]="annualMax?.progress ?? 0">
            </vpg-simple-progress-bar>
            <div class="ip-accumulator-details">
                <div
                    [id]="annualMax?.network + '-' + annualMax?.level + '-' +  annualMax?.coverage + '-spent'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'SpentColon' | translate }}</p><p class="h5">{{ annualMax?.applied }}</p></div>
                <div
                    [id]="annualMax?.network + '-' + annualMax?.level + '-' +  annualMax?.coverage + '-remaining'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'RemainingColon' | translate }}</p><p class="h5">{{ annualMax?.remaining }}</p></div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="familyDeductible">
    <h5 class="h4 ip-accumulator-title">{{ constants.PLAN_LEVEL_FAMILY | translate}}</h5>
    <div class="ip-accumulator-container-no-background">
        <div class="ip-accumulator">
            <div class="ip-accumulator-details">
                <p
                    [id]="familyDeductible?.network + '-' + familyDeductible?.level + '-' +  familyDeductible?.coverage + '-coverage'"
                    class="h5">{{ familyDeductible?.coverage ?? '' | translate }}</p>
                <div
                    [id]="familyDeductible?.network + '-' + familyDeductible?.level + '-' +  familyDeductible?.coverage + '-total'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'TotalColon' | translate }}</p><p class="h5">{{ familyDeductible?.limit }}</p></div>
            </div>
            <vpg-simple-progress-bar
                [id]="familyDeductible?.network + '-' + familyDeductible?.level + '-' +  familyDeductible?.coverage + '-progress-bar'"
                class="ip-accumulators-progress-bar"
                [size]="'small'"
                [indicator]="false"
                [progress]="familyDeductible?.progress ?? 0">
            </vpg-simple-progress-bar>
            <div class="ip-accumulator-details">
                <div
                    [id]="familyDeductible?.network + '-' + familyDeductible?.level + '-' +  familyDeductible?.coverage + '-spent'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'SpentColon' | translate }}</p><p class="h5">{{ familyDeductible?.applied }}</p></div>
                <div
                    [id]="familyDeductible?.network + '-' + familyDeductible?.level + '-' +  familyDeductible?.coverage + '-remaining'"
                    class="ip-accumulator-value"><p class="body-regular">{{ 'RemainingColon' | translate }}</p><p class="h5">{{ familyDeductible?.remaining }}</p></div>
            </div>
        </div>
    </div>
</div>
<p class="ip-accumulators-last-update">
    {{ 'LastUpdatedColon' | translate }} {{ dentalAccumulators?.lastUpdate | date: constants.DATE_FORMAT }}
</p>
